import { AxiosResponse } from 'axios';
import { instance as axios } from 'api/axios';
import { ICounterpartyCreateRequest, ICounterpartyUpdateRequest } from './interfaces';

export class Counterparty {
  public static async getList() {
    const url = '/Counterparty/List';
    const response: AxiosResponse = await axios.get(url);
    return response;
  }

  public static async getDetails(id: number) {
    const url = '/Counterparty/Details';
    const response: AxiosResponse = await axios.get(url, { params: { id } });
    return response;
  }

  public static async create(body: ICounterpartyCreateRequest) {
    const url = '/Counterparty';
    const response: AxiosResponse = await axios.post(url, body);
    return response;
  }

  public static async update(body: ICounterpartyUpdateRequest) {
    const url = '/Counterparty';
    const response: AxiosResponse = await axios.put(url, body);
    return response;
  }

  public static async delete(id: number) {
    const url = '/Counterparty';
    const response: AxiosResponse = await axios.delete(url, { params: { id } });
    return response;
  }
}
